export const dataTableConstante = Object.freeze({
  TEXT_TYPE: 1,
  LIST_TEXT_TYPE: 2,
  STATUS_TYPE: 3,
  DATE_TYPE: 4,
  DOCUMENTS_TYPE: 5,
  LIST_DOCUMENTS_TYPE: 6,
});
